import React, {Component, PureComponent} from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper/index'
import {TableComp} from 'sz-react-utils'
// import GetAllFormFields from '../../../components/_utils/formUtils'
import {Button, Card, Form,Row,Col, Tooltip, DatePicker, Select, Drawer, notification} from 'antd';
import {FormUtils as GetAllFormFields} from 'sz-react-utils'
import _ from 'lodash'
import Request, { API_URL } from '../../request'
import {connect} from 'react-redux'
import moment from 'moment'
import { RightsWrapper } from '../../components/_utils/utils'
import UpdateAppraisal from '../../components/_utils/updateAppraisal';



const {MonthPicker} = DatePicker
const Option = Select.Option;

@Form.create()
class UpdateTeamAppraisalRequest extends Component {
    state={
        visible:true,
        appraisalRequestApproved:false
    }

    handleSubmit = (e) =>{
        e.preventDefault()
        let {form, record} = this.props
        form.validateFieldsAndScroll(async(err,valData)=>{
            let values = _.clone(valData)
            values._id = record._id
            if(values.action === "Approved") {
                values.activeStatus = "Approved By HR";
                values.approvedByHod = true;
                delete values.action
            }else if (values.action === "Disapproved") {
                values.activeStatus = "Disapproved By HR";
                values.approvedByHod = false;
                values.status = values.action;
                delete values.action
            }
            let response = await Request.updateAppraisalRequest(values)
            if(response.success){
                notification.success({
                    message:response.message
                })
            }else {
                notification.error({
                    message:response.message
                })
            }
            this.onClose()
        })
    }

    setFieldsValue() {
        let {record} = this.props
        setTimeout(()=>{
            this.props.form.setFieldsValue({expectedAppraisal:record.expectedAppraisal, appraisalByHod:record.appraisalByHod})
        },50)
    }

    componentDidMount() {
        
    }

    onClose=() =>{
        setTimeout(()=>{
            this.props.onClose()
        }, 50)
    }

    render(){
        let {appraisalRequestApproved, visible} = this.state
        let inputTypes = {
            fields:[
                {
                    label:'Action',
                    key:'action',
                    type:'select',
                    options:["Approved", "Disapproved"],
                    required:true,
                    onChange:v=>{
                        this.props.form.setFieldsValue({action:v})
                        if(v === "Approved") {
                            this.setState({appraisalRequestApproved:true})
                            this.setFieldsValue()
                        }else if (v === "Disapproved") {
                            this.setState({appraisalRequestApproved:false})
                        }
                    }
                },
                {
                    label:'Expected Appraisal',
                    key:'expectedAppraisal',
                    type:'number',
                    disabled:true,
                    hidden:!appraisalRequestApproved
                },
                {
                    label:'Appraisal By HOD',
                    key:'appraisalByHod',
                    type:'number',
                    disabled:true,
                    hidden:!appraisalRequestApproved
                },
                {
                    label:'Final Appraisal',
                    key:'finalAppraisal',
                    type:'number',
                    required:appraisalRequestApproved,
                    hidden:!appraisalRequestApproved
                }
            ]
        }

        let {form:{getFieldDecorator, getFieldValue}, record} = this.props
        return (
            <Drawer
            title={`Update ${record.userId.name} Appraisal Request`}
            placement="right"
            closable={true}
            onClose={this.onClose}
            visible={visible}
            width={500}>
                <Card>
                    <Form onSubmit={this.handleSubmit}>
                        <GetAllFormFields getFieldDecorator={getFieldDecorator} apiurl={API_URL} inputSchema={inputTypes} />
                        <Row style={{marginTop:'20px'}}>
                            <Col span={8}/>
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{marginBottom: 10}}
                                    loading={this.props.loading}>
                                    Save
                                </Button>
                            </Col>
                            <Col span={8}/>
                        </Row>
                    </Form>
                </Card>

            </Drawer>
        )
    }
}
@Form.create()
class UpdateAppraisalByManagement extends Component {
    state={
        visible:true,
        appraisalRequestApproved:false
    }

    handleSubmit = (e) =>{
        e.preventDefault()
        let {form, record} = this.props
        form.validateFieldsAndScroll(async(err,valData)=>{
            let values = _.clone(valData)
            values._id = record._id
            if(values.action === "Approved") {
                values.activeStatus = "Approved By Management";
                values.status = values.action;
                values.approvedByHod = true;
                delete values.action
            }else if (values.action === "Disapproved") {
                values.activeStatus = "Disapproved By Management";
                values.approvedByHod = false;
                values.status = values.action;
                delete values.action
            }
            let response = await Request.updateAppraisalRequest(values)
            if(response.success){
                notification.success({
                    message:response.message
                })
            }else {
                notification.error({
                    message:response.message
                })
            }
            this.onClose()
        })
    }

    setFieldsValue() {
        let {record} = this.props
        setTimeout(()=>{
            this.props.form.setFieldsValue({finalAppraisal:record.finalAppraisal, salary:record.userId.salary})
        },50)
    }

    componentDidMount() {
        
    }

    onClose=() =>{
        setTimeout(()=>{
            this.props.onClose()
        }, 50)
    }

    render(){
        let {appraisalRequestApproved, visible} = this.state
        let inputTypes = {
            fields:[
                {
                    label:'Action',
                    key:'action',
                    type:'select',
                    options:["Approved", "Disapproved"],
                    required:true,
                    onChange:v=>{
                        this.props.form.setFieldsValue({action:v})
                        if(v === "Approved") {
                            this.setState({appraisalRequestApproved:true})
                            this.setFieldsValue()
                        }else if (v === "Disapproved") {
                            this.setState({appraisalRequestApproved:false})
                        }
                    }
                },
                {
                    label:'Current Salary',
                    key:'salary',
                    type:'number',
                    disabled:true,
                    hidden:!appraisalRequestApproved
                },
                {
                    label:'Final Appraisal',
                    key:'finalAppraisal',
                    type:'number',
                    required:appraisalRequestApproved,
                    hidden:!appraisalRequestApproved
                }
            ]
        }

        let {form:{getFieldDecorator, getFieldValue}, record} = this.props
        return (
            <Drawer
            title={`Update ${record.userId.name} Appraisal Request`}
            placement="right"
            closable={true}
            onClose={this.onClose}
            visible={visible}
            width={500}>
                <Card>
                    <Form onSubmit={this.handleSubmit}>
                        <GetAllFormFields getFieldDecorator={getFieldDecorator} apiurl={API_URL} inputSchema={inputTypes} />
                        <Row style={{marginTop:'20px'}}>
                            <Col span={8}/>
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{marginBottom: 10}}
                                    loading={this.props.loading}>
                                    Save
                                </Button>
                            </Col>
                            <Col span={8}/>
                        </Row>
                    </Form>
                </Card>

            </Drawer>
        )
    }
}




@Form.create()
class AddStaffAppraisals extends Component {
    state = {
        allUsers:[],
        recordId:''
    }

    componentDidMount() {
        let {users, userData} = this.props;
        this.setState({allUsers:users})
    }

    handleSubmit = (e) =>{
        let {form, dispatch, handleAddAppraisal} = this.props
        e.preventDefault();
        form.validateFieldsAndScroll(async(err,valData)=>{
            let values = _.clone(valData)
            handleAddAppraisal(values)
        })
    }

    render() {
        let {allUsers} = this.state
        let {form:{getFieldDecorator, getFieldValue}} = this.props
        const inputTypes = {
            fields:[
                {
                    label:'Select User',
                    key:'userId',
                    type:'select',
                    required:true,
                    showSearch:true,
                    options:allUsers,
                    onChange:v=>{
                        this.props.form.setFieldsValue({userId:v})
                    }
                },
                {
                    label:'Appraisal Type',
                    key:'appraisalType',
                    type:'select',
                    required:true,
                    showSearch:true,
                    options:["Performance Appraisal", "Annual Appraisal"],
                    onChange:v=>{
                        this.props.form.setFieldsValue({appraisalType:v})
                    }
                },
                {
                    label:'Last Apprisal Date',
                    key:'lastApprisalDate',
                    type:'date',
                    required:true,
                },
                {
                    label:'Expected Appraisal',
                    key:'expectedAppraisal',
                    type:'number'
                },
                {
                    label:'Final Appraisal',
                    key:'finalAppraisal',
                    type:'number'
                },
                {
                    label:'Status',
                    key:'status',
                    type:'select',
                    required:true,
                    showSearch:true,
                    options:['Approved', 'Disapproved'],
                    onChange:v=>{
                        this.props.form.setFieldsValue({status:v})
                    }
                }
            ]
        }
        return (
            <Card>
                <Form onSubmit={this.handleSubmit}>
                    <GetAllFormFields apiurl={API_URL} inputSchema={inputTypes} getFieldDecorator={getFieldDecorator} />
                    <Row style={{marginTop:'20px'}}>
                            <Col span={8}/>
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{marginBottom: 10}}
                                    loading={this.props.loading}>
                                    Save
                                </Button>
                            </Col>
                            <Col span={8}/>
                        </Row>
                </Form>
            </Card>
        )
    }
}


@Form.create()
class AppraisalStaff extends PureComponent {
    state = {
        studentId: '',
        count: 0,
        defaultPageSize: 20,
        month:moment(),
        activityArr: [],
        record:{},
        allUsers:[],
        userId:null,
        showAppraisalAddForm:false,
        showAppraisalEditForm:false,
        showAprraisalRequestEdit:false,
        showApprovalByManagement:false,
        activeUser:{},
    }



    refreshFxn = () => {
        this.setState({refreshChild: !this.state.refreshChild})
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
    }

    handleAppraisalRequestEdit = (record)=>{
        this.setState({showAprraisalRequestEdit:true, record:record})
    }

    handleActionByManagement = (record) =>{
        this.setState({showApprovalByManagement:true, record:record})
    }

    closeEditForm = () =>{
        this.setState({showAprraisalRequestEdit:false, record:{}, showApprovalByManagement:false})
        this.table.current.reload()
    }

    handleStaffLeaveApplication = (record) =>{
        this.setState({showLeaveActionForm:true, record:record})
    }

    handleStaffLeaveApplicationClose = () =>{
        this.setState({showLeaveActionForm:false, record:{}})
        this.table.current.reload()
    }

    handleAdd=()=>{
        this.setState({showAppraisalAddForm:true})
    }

    handleClose = () =>{
        this.setState({showLeaveAddForm:false})
        this.reload()
    }

    onClose = () =>{
        this.setState({showAppraisalAddForm:false, record:{}, viewDetailRecord:{}, showAppraisalEditForm:false})
        this.reload()
    }

    apiRequest = params =>{
        return new Promise(async(resolve)=>{
            params.sortField = "createdByUser.time"
            params.sortOrder = "descend"
            if(this.state.userId) {
                params.userId = this.state.userId
            }
            let response = await Request.getStaffAppraisalRequests(params);
            this.setState({count:response.total})
            resolve(response)
        })
    }

    getCurrentUser() {
        let response = JSON.parse(localStorage.getItem('user'));
        this.setState({activeUser:response})
        return response
    }

    handleMonthChange = (month,dateString) =>{
        this.setState({month:moment(month)}, ()=>{
            this.reload()
        })
    }


    handleAppraisalEdit = (data) =>{
        this.setState({record:data, showAppraisalEditForm:true})
    }

    async componentDidMount() {
        let currentUser = await this.getCurrentUser()
        let params = {
            sortField:'_id',
            sortOrder:'ascend',
            results: 200,
            active:true,
            userType:{$ne : "Student"},
            userBranch:currentUser.userBranch,
        };
        let response = await Request.loadUser({...params, regExFilters: ['name']})
        let userArray = [];
        response.data.map((user, index)=>{
            userArray.push({
                _id: user._id,
                display: user.name
            })
        })
        this.setState({allUsers:userArray})
    }

    reload = () => {    
        this.table.current.reload();
    };

    render() {
        const {defaultPageSize,showApprovalByManagement, showLeaveActionForm,showAprraisalRequestEdit, activeUser, count, record, allUsers, showAppraisalAddForm, showAppraisalEditForm} = this.state
        const columns = [
            {
                title:'Employee Name',
                key:'userId.name',
                fixed:'left',
                width:150
            },
            {
                title:'Requested Appraisal Type',
                key:'appraisalType'
            },
            {
                title:'Current Salary',
                key:'userId.salary',
            },
            {
                title:'Date of Joining',
                key:'userId.dateOfJoining',
                render:(text,record)=>(
                    <div>{moment(text).format('DD-MMMM-YYYY')}</div>
                )
            },
            {
                title:'Last Appraisal',
                key:'previousAppraisal',
                render:(text,record)=>(
                    <div>{moment(text).format("DD-MMMM-YYYY")}</div>
                )
            },
            {
                title:'Expected Appraisal',
                key:'expectedAppraisal'
            },
            {
                title:'Suggested Appraisal By HOD',
                key:'appraisalByHod'
            },
            {
                title:'HOD Name',
                key:'hodName',
                dataIndex:'hodId.name'
            },
            {
                title:'Final Appraisal Amount',
                key:'finalAppraisal'
            },
            {
                title:'Approval Status',
                key:'activeStatus',
            },
            {
                title:'Performance Report',
                key:'employeeReport'
            },
            {
                title:'Appraisal Status',
                key:'status'
            },
            {
                title:'Action',
                key:'operation',
                dataindex: "operation",
                render: (text, record) => (
                    <React.Fragment>
                    {record.activeStatus === "Approved By Hod" && activeUser.isHRManager?
                    <Tooltip title="Edit Appraisal Request">
                        <Button
                          size={"small"}
                          shape="circle"
                          onClick={() => this.handleAppraisalRequestEdit(record)}
                          icon="edit"
                        />
                    </Tooltip>
                    :null}
                    {
                        record.activeStatus === "Approved By HR" && !activeUser.isHRManager?
                        <Tooltip title="Edit Appraisal Request">
                            <Button
                            size={"small"}
                            shape="circle"
                            onClick={() => this.handleActionByManagement(record)}
                            icon="forward"
                            />
                        </Tooltip>
                        :null
                    }
                  </React.Fragment>
                ),
            }
        ]
        
    return (
        <PageHeaderWrapper title={`Staff Appraisals:- ${count}` }>
            {
                showAprraisalRequestEdit?
                <UpdateTeamAppraisalRequest record={record} onClose={this.closeEditForm} />
                :null
            }
            {
                showApprovalByManagement?
                <UpdateAppraisalByManagement record={record} onClose={this.closeEditForm} />
                :null
            }
            {
                showAppraisalEditForm?
                <UpdateAppraisal allUsers={allUsers} record={record} onClose={this.onClose} />
                :null
            }
            <Card bordered={true}>
                <Row>
                    <Col span={6}>
                        <label>Search by User</label>
                        <Select 
                            allowClear
                            showSearch={true}
                            style={{width: '90%'}}
                            value={this.state.userId}
                            placeholder="Select Option"
                            optionFilterProp="name"
                            onChange={userId => {
                                this.setState(
                                    {
                                      userId: userId && userId.toString()
                                    },
                                    () => {
                                        setTimeout(() => {
                                            this.reload()
                                        }, 500);
                                    }
                                );
                            }}
                            filterOption={(input, option) => {
                                return (
                                    option.props.children
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                );
                            }}
                        >
                        {
                            allUsers.map((val,idn)=>{
                                return(
                                    <Option key={idn} value={val._id}>{val.display}</Option>
                                )
                            })
                        }

                        </Select>
                    </Col>
                    <Col span={2}>
                        <div style={{textAlign: 'right', marginTop: '15px'}}>
                            <Button onClick={()=>this.handleAdd()}>Add</Button>
                        </div>
                    </Col>
                </Row>
            </Card>
            <Card bordered={true} >
                <TableComp
                    ref={this.table}
                    columns={columns}
                    apiRequest={this.apiRequest}
                    extraProps={{ scroll: { x: 1500 } }}
                    pagination={{
                        showSizeChanger: true,
                        defaultPageSize: defaultPageSize,
                        pageSizeOptions: ['10', '20', '50', '100', '1000']
                    }}
                />
            </Card>

            <Drawer
                    title="Add Team Appraisal"
                    placement="right"
                    closable={true}
                    onClose={this.onClose}
                    visible={showAppraisalAddForm}
                    width={500}>
                    <div>
                        <AddStaffAppraisals
                            loading={this.props.loading}
                            users={allUsers}
                            userData={record}
                            handleAddAppraisal={async(values)=>{
                                let response = await Request.addStaffAppraisal(values)
                                if(response.success) {
                                    notification.success({
                                        message:response.message
                                    })
                                }else {
                                    notification.error({
                                        message:response.message
                                    })
                                }
                                this.onClose()
                            }}
                        />
                    </div>
            </Drawer>
        </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({global, router}) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search,
    pathname: router.location.pathname
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AppraisalStaff)
